module.exports = __webpack_public_path__ + "static/media/01.ac7ce871.jpg";